var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useRef, useEffect } from 'react';
import { Menu, Dropdown, Btn, Item } from './Menu.styles';
import '@fortawesome/fontawesome-free/js/all';
var MenuCmp = function (_a) {
    var mode = _a.mode, children = _a.children;
    var _b = __read(useState(false), 2), open = _b[0], setOpen = _b[1];
    var node = useRef(null);
    var handleClickOutside = function (e) {
        if (node.current.contains(e.target)) {
            return;
        }
        setOpen(false);
    };
    useEffect(function () {
        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);
    return (React.createElement(Menu, null,
        React.createElement(Btn, { mode: mode, onClick: function () { return setOpen(!open); } },
            React.createElement("i", { className: "fas fa-cog" })),
        React.createElement(Dropdown, { ref: node, mode: mode, open: open }, children)));
};
var ItemCmp = function (_a) {
    var children = _a.children;
    return React.createElement(Item, null, children);
};
MenuCmp.Item = ItemCmp;
export default MenuCmp;
